import { configureStore, combineReducers } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import * as resourceReducers from './resourceReducers';

export const initStore = (loggedInUser = null) => configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  preloadedState: {
    auth: {
      loggedInUser: loggedInUser && loggedInUser._id ? loggedInUser : null,
      status: "idle",
      error: null,
    },
  },
})

const rootReducer = (state, action) => {
  if (
      action.type === 'auth/sendLogout/fulfilled' ||
      action.type === 'auth/sendLogout/rejected' ||
      action.type === 'auth/sendLogin/fulfilled' ||
      action.type === 'auth/sessionExpired'
  ) {
    state = undefined
  }
  return combinedReducers(state, action)
}

const combinedReducers = combineReducers({
  ...resourceReducers
})